import { Dimension } from "../../../components/FileUploadComponent/constants";

export type BannerMobileFileProps = {
	isUpper?: boolean;
};

export const FileUploadItem =
{
	key: "image",
	label: "Mobil Banner",
	maxFileSize: "20971520",
	extensions: ["jpeg", "jpg", "png"],
	isRequired: true,
	default: "imageUrl",
	dimensions: {
		upper: [{ width: 768, height: 1024 }] as Dimension[],
		lower: [{ width: 576, height: 576 }] as Dimension[]
	}
};
